import * as THREE from 'three';
import { hexToWorld, type MapDef } from '@somnhold/sim';
import { simToWorld } from '@somnhold/render';
import { t } from '../i18n.ts';
import { h } from '../ui/dom.ts';

/**
 * «Path 1», «Path 2»… over each gate of the bastion (where the road comes in, always in view), so
 * «I'll take path 1» points at something on the field (the numbers are the ones the ghost's post uses).
 */
export class PathTags {
  readonly el = h('div.path-tags');
  private spots: { el: HTMLElement; at: THREE.Vector3; last: string }[] = [];
  private v = new THREE.Vector3();
  private key = '';

  place(map: MapDef, camera: THREE.Camera, w: number, ht: number): void {
    // Terraced land has no roads nor gates fixed: a tag would tell where the wave comes from (docs/CONSTRUCCION.md).
    const key = map.kind === 'bastion' && !map.land ? map.sectors.map((s) => `${s.index}:${s.gate.q},${s.gate.r}`).join('|') : '';
    if (key !== this.key) this.build(map, key);
    for (const s of this.spots) {
      this.v.copy(s.at).project(camera);
      const pos = this.v.z > 1 ? 'off' : `translate(${Math.round((this.v.x * 0.5 + 0.5) * w)}px, ${Math.round((-this.v.y * 0.5 + 0.5) * ht)}px) translate(-50%, -50%)`;
      if (pos === s.last) continue;
      s.last = pos;
      s.el.hidden = pos === 'off';
      if (pos !== 'off') s.el.style.transform = pos;
    }
  }

  private build(map: MapDef, key: string): void {
    this.key = key;
    this.el.replaceChildren();
    this.spots = [];
    if (!key) return;
    for (const s of map.sectors) {
      const c = hexToWorld(s.gate.q, s.gate.r);
      const el = h('span.path-tag', { 'data-test': `path-${s.index + 1}` }, t('bastion.sector', { n: s.index + 1 }));
      this.el.append(el);
      this.spots.push({ el, at: simToWorld(c.x, c.y).setY(1.3), last: '' });
    }
  }
}
